import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { ReactComponent as WarningFilledSvg } from '../../../../../../assets/icon/WarningFilled.svg';
import styles from '../../../Style/DatasetInfo.module.scss';
import { locationInfoMessages } from './locationDisplay.utils';

interface LandWarningInfoProps {
  showLandWarning: boolean;
}

export const LandWarningInfo = ({ showLandWarning }: LandWarningInfoProps) => {
  if (!showLandWarning) return null;

  return (
    <div className={styles.landRelationWarning}>
      <div className={styles.landRelationWarningContent}>
        <WarningFilledSvg />
        <span>{locationInfoMessages.closeToLand}</span>
      </div>
      <Tooltip
        title={locationInfoMessages.closeToLandTooltip}
        overlayStyle={{ maxWidth: '300px' }}
      >
        <InfoCircleOutlined className={styles.landRelationInfoIcon} />
      </Tooltip>
    </div>
  );
};
